// Frontend client for the Inventory Engines API.
// Every number on the Morning Brief and the engine drawers comes from here.

const BACKEND = process.env.REACT_APP_BACKEND_URL;

async function j(method, path, body) {
  const res = await fetch(`${BACKEND}/api${path}`, {
    method,
    headers: body ? { "Content-Type": "application/json" } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  const text = await res.text();
  const payload = text ? JSON.parse(text) : null;
  if (!res.ok) {
    const detail = (payload && payload.detail) || `HTTP ${res.status}`;
    const err = new Error(detail);
    err.status = res.status;
    throw err;
  }
  return payload;
}

export const ENGINES = [
  { id: "demand_forecast",    label: "Demand Forecasting",      accent: "indigo",   icon: "trending-up" },
  { id: "stockout_adjusted",  label: "Stockout-Adjusted Demand",accent: "slate",    icon: "activity" },
  { id: "inventory_health",   label: "Inventory Health & Excess",accent:"amber",    icon: "wallet" },
  { id: "stockout_risk",      label: "Stockout Risk Prediction",accent: "critical", icon: "alert-triangle" },
  { id: "replenishment",      label: "Replenishment Optimisation",accent:"primary", icon: "shopping-cart" },
  { id: "redistribution",     label: "Inventory Redistribution",accent: "teal",     icon: "arrow-right-left" },
  { id: "aging",              label: "Aging / Dead-Stock",      accent: "warning",  icon: "clock" },
];

// Overview + health
export function enginesOverview() { return j("GET", "/engines"); }
export function latestCycle() { return j("GET", "/engines/cycle/latest"); }
export function cycleHistory(limit = 10) { return j("GET", `/engines/cycle/history?limit=${limit}`); }
export function runNow(actor = "ui") { return j("POST", `/engines/run-now?actor=${encodeURIComponent(actor)}`); }
export function runSingle(engine, actor = "ui") {
  return j("POST", `/engines/${encodeURIComponent(engine)}/run-now?actor=${encodeURIComponent(actor)}`);
}
export function setEngineConfig(engine, { mode, thresholds }) {
  return j("POST", `/engines/${encodeURIComponent(engine)}/config`, { mode, thresholds });
}

// Recommendations
export function listRecommendations({ engine, include_shadow, branch_id, limit = 200 } = {}) {
  const qs = new URLSearchParams();
  if (engine) qs.set("engine", engine);
  if (include_shadow) qs.set("include_shadow", "true");
  if (branch_id) qs.set("branch_id", branch_id);
  qs.set("limit", String(limit));
  return j("GET", `/engines/recommendations?${qs.toString()}`);
}
export function approveRec(id, { actor, note } = {}) {
  return j("POST", `/engines/rec/${encodeURIComponent(id)}/approve`, { actor, note });
}
export function rejectRec(id, { actor, note } = {}) {
  return j("POST", `/engines/rec/${encodeURIComponent(id)}/reject`, { actor, note });
}
export function snoozeRec(id, { actor, note } = {}) {
  return j("POST", `/engines/rec/${encodeURIComponent(id)}/snooze`, { actor, note });
}

export function morningBrief(branch_id) {
  const qs = branch_id ? `?branch_id=${encodeURIComponent(branch_id)}` : "";
  return j("GET", `/engines/brief${qs}`);
}
